import { Box, Paper } from '@mui/material';

import { gql } from '@graphql/__generated__';
import { type ListingMapFragment } from '@graphql/__generated__/graphql';
import { PropertyMapViewer } from '@modules/_shared/components/property-map/PropertyMapViewer';

export const LISTING_MAP_FRAGMENT = gql(/* GraphQL */ `
  fragment ListingMap on properties {
    id
    lat
    lng
    google_address {
      lat
      lng
    }
  }
`);

interface IProps {
  property: ListingMapFragment;
  hideMarker?: boolean;
}

export const ListingMap: React.FC<IProps> = ({
  property,
  hideMarker = false,
}) => {
  const lat = property.lat ?? property.google_address?.lat;
  const lng = property.lng ?? property.google_address?.lng;

  if (lat == null || lng == null) {
    return null;
  }

  return (
    <Paper
      sx={{
        position: 'relative',
        borderRadius: 2,
        overflow: 'hidden',
        pt: '60%',
      }}
      elevation={0}
      component="div"
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
        }}
      >
        <PropertyMapViewer
          lat={lat}
          lng={lng}
          initialMode="map"
          modeOrder={
            hideMarker ? ['map'] : ['map', 'satellite', '3d', 'streetView']
          }
          defaultZoom={10}
          hideMarker={hideMarker}
          controlSize={32}
        />
      </Box>
    </Paper>
  );
};
